import angular from "angular";
import component from "./schedule-generate.component";

angular.module('scheduleGenerate', [component]);

export default "scheduleGenerate";


// WEBPACK FOOTER //
// ./resources/assets/modules/schedule-generate/schedule-generate.module.js